// extracted by mini-css-extract-plugin
module.exports = {"list__empty":"list_list__empty__cOaRh"};